import {
  createGenericEntityAdapter,
  createGenericEntitySlice,
} from "generics/entitiySlice";
import { Order } from "klikni-jadi-shared-stuff";
import { RootState } from "store";

const entityAdapter = createGenericEntityAdapter((order: Order) => order.id);

export const slice = createGenericEntitySlice({
  name: "orders",
  entityAdapter,
  initialState: entityAdapter.getInitialState({
    loading: false,
    error: null,
  }),
  reducers: {},
});

export const selector = entityAdapter.getSelectors<RootState>(
  (state) => state.orders
);

export const reducer = slice.reducer;
